import React, { useCallback, useEffect, useState } from 'react';
import { SessionState } from 'sip.js';
import { SessionDirection } from '../../helper/sipProvider';
import usePhoneConnection from '../../helper/usePhoneConnection';
import { downloadPhoneDiagnostics } from '../../helper/phoneDiagnostics';
import { CallGETAPI } from '../../helper/Constants';
import IncomingCallModal from '../models/IncomingCallModal';

const ACTIVE_SESSION_STATES = new Set([
  SessionState.Initial,
  SessionState.Establishing,
  SessionState.Established,
]);

const getSessionDirection = (session = null) =>
  session?.incomingInviteRequest
    ? SessionDirection.INCOMING
    : SessionDirection.OUTGOING;

const getSessionDialedNumber = (session = null) =>
  String(
    session?.request?.to?.uri?.user ||
      session?.outgoingRequestMessage?.to?.uri?.user ||
      ""
  ).trim();

const isMonitorFeatureCodeSession = (session = null) =>
  getSessionDirection(session) === SessionDirection.OUTGOING &&
  /^(551|552|553)/.test(getSessionDialedNumber(session));

const getRenderableSessionIds = (sessions = {}) => {
  const sessionEntries = Object.entries(sessions || {}).filter(
    ([, session]) => session && ACTIVE_SESSION_STATES.has(session.state)
  );

  const inboundRingingEntries = sessionEntries.filter(([, session]) => {
    const direction = getSessionDirection(session);
    return (
      direction === SessionDirection.INCOMING &&
      (session.state === SessionState.Initial ||
        session.state === SessionState.Establishing)
    );
  });

  if (inboundRingingEntries.length > 0) {
    return inboundRingingEntries.map(([sessionId]) => sessionId);
  }

  const visibleEntries = sessionEntries.filter(
    ([, session]) => !isMonitorFeatureCodeSession(session)
  );

  if (!visibleEntries.length) {
    return [];
  }

  return [visibleEntries[visibleEntries.length - 1][0]];
};


export default function HandleCallCenter() {
  const { connectPhone, phoneStatus, sessions } = usePhoneConnection();
  const [sip, setSip] = useState('');
  const [showHistory, setShowHistory] = useState([]);
  useEffect(() => {
    let cancelled = false;
    CallGETAPI('api/get-user-extension').then(response => {
      const record = response?.data?.data;
      if (cancelled || !record || record.browser_compatible === false) return;
      setSip(record.id);
      connectPhone(record);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [connectPhone]);
  const fetchCallHistory = useCallback(async () => {
    if (!sip) return;
    const response = await CallGETAPI(`api/call-history-v2/?extension=${encodeURIComponent(sip)}`);
    if (response.status) setShowHistory(response.data.data);
  }, [sip]);
  return <>
    <div role="status" className="fixed bottom-2 right-4 z-50 rounded bg-white px-3 py-1 text-xs text-slate-700 shadow">
      {phoneStatus} <button type="button" className="ml-2 underline" onClick={downloadPhoneDiagnostics}>Download diagnostics</button>
    </div>
    {getRenderableSessionIds(sessions).map(sessionId => <IncomingCallModal key={sessionId} sessionId={sessionId}
      setShowHistory={setShowHistory} showHistory={showHistory} fetchCallHistory={fetchCallHistory} />)}
  </>;
}
